// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Ogkv","savePackageButton":"ClientWallet_savePackageButton__3QWJC"};